module.exports = __webpack_public_path__ + "img/sn.bbc9715d.svg";